import { trackStructuredEvent } from 'js/helpers/google-tag-manager';

export const trackRedeemCredit = () => {
  return trackStructuredEvent({
    category: 'welcoming_page',
    property: 'redeem_credit',
    action: 'click',
  });
};
